import React from 'react';
import './style.scss';

export type ConsentLinkProps = {
  linkTitle?: string;
  linkUrl?: string;
  onClick?: () => void;
};

export const ConsentLink = (props: ConsentLinkProps) => {
  const { linkTitle, linkUrl, onClick } = props;
  return (
    <a
      className="consentLink"
      href={linkUrl}
      target="_blank"
      rel="noreferrer noopener"
      onClick={() => {
        onClick && onClick();
      }}
    >
      {linkTitle}
    </a>
  );
};
